/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal Pre-Auth
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PreparedLogout } from '../model';
/**
 * LogoutApi - axios parameter creator
 * @export
 */
export const LogoutApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cognito also returns the browser here after its own logout, because this is the sign-out URL its app clients allow. That return is a navigation with no query, never ends a session, and redirects to the Resume page. The application\'s logout always has a query. 
         * @summary Invalidates current user\'s session.
         * @param {'idle' | 'ended'} [reason] Why the session is ending. With idle (an idle timeout) or ended (the session ended some other way, such as a failed activity check-in), the user\&#39;s resume records are kept, so waiting tabs can still return to their pages after the next login. An explicit logout sends no reason, and any logout without one of these reasons deletes them. 
         * @param {string} [expectedSessionInstanceId] For an automatic logout, the opaque session instance identifier returned by the activity ping. If the browser now presents a different live session, the server leaves it active and returns 204. Explicit logout does not send this value and remains unconditional. Compare it only for equality; its contents have no client-visible meaning. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (reason?: 'idle' | 'ended', expectedSessionInstanceId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }

            if (expectedSessionInstanceId !== undefined) {
                localVarQueryParameter['expectedSessionInstanceId'] = expectedSessionInstanceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Called by the client\'s continuation page before it navigates to Cognito\'s logout, which ends the identity provider\'s session for the whole browser. If the application\'s logout failed, the session the request names is ended here first, provided it is still the browser\'s. The page rechecks the browser\'s other tabs after the response arrives, and navigates only if no login has started since. Both responses are Cache-Control: no-store: a cached 204 for the unnamed URL would skip Cognito on a later logout. 
         * @summary Returns Cognito\'s logout URL, after the application\'s logout.
         * @param {'idle'} [reason] idle after an idle timeout, which keeps the user\&#39;s resume records if the named session is ended here. An explicit logout sends no reason, and ending its session deletes them. 
         * @param {string} [expectedSessionInstanceId] The opaque session instance identifier of the session the tab was logging out of, as the activity ping returned it. If the browser still presents that session, it is ended. If the browser presents a different live session, or the request names none and any session is live, the server returns 204. Compare it only for equality. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareLogout: async (reason?: 'idle', expectedSessionInstanceId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout/prepare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }

            if (expectedSessionInstanceId !== undefined) {
                localVarQueryParameter['expectedSessionInstanceId'] = expectedSessionInstanceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogoutApi - functional programming interface
 * @export
 */
export const LogoutApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogoutApiAxiosParamCreator(configuration)
    return {
        /**
         * Cognito also returns the browser here after its own logout, because this is the sign-out URL its app clients allow. That return is a navigation with no query, never ends a session, and redirects to the Resume page. The application\'s logout always has a query. 
         * @summary Invalidates current user\'s session.
         * @param {'idle' | 'ended'} [reason] Why the session is ending. With idle (an idle timeout) or ended (the session ended some other way, such as a failed activity check-in), the user\&#39;s resume records are kept, so waiting tabs can still return to their pages after the next login. An explicit logout sends no reason, and any logout without one of these reasons deletes them. 
         * @param {string} [expectedSessionInstanceId] For an automatic logout, the opaque session instance identifier returned by the activity ping. If the browser now presents a different live session, the server leaves it active and returns 204. Explicit logout does not send this value and remains unconditional. Compare it only for equality; its contents have no client-visible meaning. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(reason?: 'idle' | 'ended', expectedSessionInstanceId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(reason, expectedSessionInstanceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Called by the client\'s continuation page before it navigates to Cognito\'s logout, which ends the identity provider\'s session for the whole browser. If the application\'s logout failed, the session the request names is ended here first, provided it is still the browser\'s. The page rechecks the browser\'s other tabs after the response arrives, and navigates only if no login has started since. Both responses are Cache-Control: no-store: a cached 204 for the unnamed URL would skip Cognito on a later logout. 
         * @summary Returns Cognito\'s logout URL, after the application\'s logout.
         * @param {'idle'} [reason] idle after an idle timeout, which keeps the user\&#39;s resume records if the named session is ended here. An explicit logout sends no reason, and ending its session deletes them. 
         * @param {string} [expectedSessionInstanceId] The opaque session instance identifier of the session the tab was logging out of, as the activity ping returned it. If the browser still presents that session, it is ended. If the browser presents a different live session, or the request names none and any session is live, the server returns 204. Compare it only for equality. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareLogout(reason?: 'idle', expectedSessionInstanceId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreparedLogout>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareLogout(reason, expectedSessionInstanceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LogoutApi - factory interface
 * @export
 */
export const LogoutApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogoutApiFp(configuration)
    return {
        /**
         * Cognito also returns the browser here after its own logout, because this is the sign-out URL its app clients allow. That return is a navigation with no query, never ends a session, and redirects to the Resume page. The application\'s logout always has a query. 
         * @summary Invalidates current user\'s session.
         * @param {'idle' | 'ended'} [reason] Why the session is ending. With idle (an idle timeout) or ended (the session ended some other way, such as a failed activity check-in), the user\&#39;s resume records are kept, so waiting tabs can still return to their pages after the next login. An explicit logout sends no reason, and any logout without one of these reasons deletes them. 
         * @param {string} [expectedSessionInstanceId] For an automatic logout, the opaque session instance identifier returned by the activity ping. If the browser now presents a different live session, the server leaves it active and returns 204. Explicit logout does not send this value and remains unconditional. Compare it only for equality; its contents have no client-visible meaning. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(reason?: 'idle' | 'ended', expectedSessionInstanceId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.logout(reason, expectedSessionInstanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Called by the client\'s continuation page before it navigates to Cognito\'s logout, which ends the identity provider\'s session for the whole browser. If the application\'s logout failed, the session the request names is ended here first, provided it is still the browser\'s. The page rechecks the browser\'s other tabs after the response arrives, and navigates only if no login has started since. Both responses are Cache-Control: no-store: a cached 204 for the unnamed URL would skip Cognito on a later logout. 
         * @summary Returns Cognito\'s logout URL, after the application\'s logout.
         * @param {'idle'} [reason] idle after an idle timeout, which keeps the user\&#39;s resume records if the named session is ended here. An explicit logout sends no reason, and ending its session deletes them. 
         * @param {string} [expectedSessionInstanceId] The opaque session instance identifier of the session the tab was logging out of, as the activity ping returned it. If the browser still presents that session, it is ended. If the browser presents a different live session, or the request names none and any session is live, the server returns 204. Compare it only for equality. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareLogout(reason?: 'idle', expectedSessionInstanceId?: string, options?: any): AxiosPromise<PreparedLogout> {
            return localVarFp.prepareLogout(reason, expectedSessionInstanceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogoutApi - object-oriented interface
 * @export
 * @class LogoutApi
 * @extends {BaseAPI}
 */
export class LogoutApi extends BaseAPI {
    /**
     * Cognito also returns the browser here after its own logout, because this is the sign-out URL its app clients allow. That return is a navigation with no query, never ends a session, and redirects to the Resume page. The application\'s logout always has a query. 
     * @summary Invalidates current user\'s session.
     * @param {'idle' | 'ended'} [reason] Why the session is ending. With idle (an idle timeout) or ended (the session ended some other way, such as a failed activity check-in), the user\&#39;s resume records are kept, so waiting tabs can still return to their pages after the next login. An explicit logout sends no reason, and any logout without one of these reasons deletes them. 
     * @param {string} [expectedSessionInstanceId] For an automatic logout, the opaque session instance identifier returned by the activity ping. If the browser now presents a different live session, the server leaves it active and returns 204. Explicit logout does not send this value and remains unconditional. Compare it only for equality; its contents have no client-visible meaning. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogoutApi
     */
    public logout(reason?: 'idle' | 'ended', expectedSessionInstanceId?: string, options?: any) {
        return LogoutApiFp(this.configuration).logout(reason, expectedSessionInstanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Called by the client\'s continuation page before it navigates to Cognito\'s logout, which ends the identity provider\'s session for the whole browser. If the application\'s logout failed, the session the request names is ended here first, provided it is still the browser\'s. The page rechecks the browser\'s other tabs after the response arrives, and navigates only if no login has started since. Both responses are Cache-Control: no-store: a cached 204 for the unnamed URL would skip Cognito on a later logout. 
     * @summary Returns Cognito\'s logout URL, after the application\'s logout.
     * @param {'idle'} [reason] idle after an idle timeout, which keeps the user\&#39;s resume records if the named session is ended here. An explicit logout sends no reason, and ending its session deletes them. 
     * @param {string} [expectedSessionInstanceId] The opaque session instance identifier of the session the tab was logging out of, as the activity ping returned it. If the browser still presents that session, it is ended. If the browser presents a different live session, or the request names none and any session is live, the server returns 204. Compare it only for equality. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogoutApi
     */
    public prepareLogout(reason?: 'idle', expectedSessionInstanceId?: string, options?: any) {
        return LogoutApiFp(this.configuration).prepareLogout(reason, expectedSessionInstanceId, options).then((request) => request(this.axios, this.basePath));
    }
}
